import {
  updateClasses,
  scrollToTop,
  scrollToSection,
  assignNavHeightValues,
  // menuClasses,
  initialMenuState,
  removeUlSubActive,
  crumbObserver,
  closeNavigation

} from '../../modules/navigation/nav-helpers';

import {
  setgridheight
} from '../../modules/grid/grid-helpers';

import {
  assignColors
} from '../../modules/colors/index';

import {
  animatedLogosInit
} from '../../modules/animatedlogos/index';

import {
  animatedArrowsInit
} from '../../modules/animatedarrows/index';

import {
  animatedLogo
} from '../../modules/animatedlogos/logo-helpers';

import {
  slider
} from '../../modules/slider/index';

import {
  revitLayers
} from '../revitlayers/index';
import jQuery from 'jquery';

//Block
import blocks from '../../modules/blocks/index';
import formPosition from '../../modules/forms/index';
import barba from '@barba/core';

export default function init(flickityNav, touch, devGridOn_iso, devGridOn_rows, devGridOn_columns, devGridOn_baselines, devGridOn_vertlines, orientationValue) {

  var $ = jQuery;

  console.log("barba init");

  barba.init({
    requestError: (trigger, action, url, response) => {
      // console.log("requestError")
      // go to a custom 404 page if the user click on a link that return a 404 response status
      if (action === 'click' && response.status && response.status === 404) {
        barba.go('/404');
        console.log("404 barba error"); // reivew this and other 404 pages
      }

      // prevent Barba from redirecting the user to the requested URL
      // this is equivalent to e.preventDefault() in this context
      return false;
    },
    views: [{
        namespace: 'home-page',
        afterEnter(data) {
          console.log("afterEnter(data): namespace = homepage");
          var nextContainer = data.next.container,
            $container = $(nextContainer);

          revitLayers($container, "home-page");
          blocks($container);

          console.log("afterEnter(data): namespace = homepage - should have finished loading slider; revit etc");

        }
      },
      {
        namespace: 'about-page',
        afterEnter(data) {
          var container = data.next.container;
          // $container = $(nextContainer);
          // console.log("afterEnter(data): namespace = aboutpage");
          animatedLogosInit(container, "about-page");
        }
      },
      {
        namespace: 'approach-page',
        afterEnter(data) {
          var container = data.next.container;
          // $container = $(nextContainer);
          // console.log("afterEnter(data): namespace = approach page");
          animatedLogosInit(container, "approach-page"); // review the use of this across the board
        }
      },
      {
        namespace: 'page',
        afterEnter(data) {

          console.log("afterEnter: namespace = page");
          var container = data.next.container,
            $container = $(container),
            nextHtml = data.next.html,
            response = nextHtml.replace(/(<\/?)body( .+?)?>/gi, '$1notbody$2>', nextHtml),
            bodyClasses = $(response).filter('notbody').attr('class'),
            direction = 'in'; // to determine where to move the form

          if (bodyClasses.includes('page-id-2540')) {
            // local; information management page (review online ID; should be the same though)
            console.log("hello information management page id:", bodyClasses);

            formPosition(direction);
          }

          // used on:
          //- brand guide page
          // - list others here
          blocks($container);

        }
      },
      {
        namespace: 'single-news',
        afterEnter(data) {
          // console.log("afterEnter: namespace = single: news ");
          var $container = $(data.next.container);
          blocks($container);
        }
      },
      {
        namespace: 'single-ideas',
        afterEnter(data) {
          // console.log("afterEnter: namespace = single: news ");
          var $container = $(data.next.container);
          blocks($container);
        }
      },
      {
        namespace: 'single-projects',
        afterEnter(data) {
          console.log("afterEnter: namespace = single projects - start");
          //
          var container = data.next.container, //is the next page
            $container = $(container);

          slider(container);
          revitLayers($container, "single-projects");
          animatedLogosInit(container, "single-projects"); // review the use of this across the board
          // revitLayers("single-projects");

          console.log("afterEnter: namespace = single projects - should have finished loading slider; revit etc");
        }
      },
      {
        namespace: 'single-clients',
        afterEnter(data) {
        console.log("afterEnter: namespace = single clients");

          var container = data.next.container, //is the next page
            $container = $(container);
          slider(container);
          revitLayers($container, "single-clients");

        }
      },
      {
        namespace: 'archive-news',
        afterEnter(data) {
          // console.log("afterEnter: namespace = archive: projects, news");

        }
      },
      {
        namespace: 'archive-ideas',
        afterEnter(data) {
          // console.log("afterEnter: namespace = archive: projects, news");

        }
      },
      {
        namespace: 'archive-projects',
        afterEnter(data) {
          // console.log("afterEnter: namespace = archive: projects");

          var container = data.next.container, //is the next page
            $container = $(container);
          revitLayers($container, "archive-projects");

        }
      },
      {
        namespace: 'error-404',
        afterEnter(data) {
          console.log("afterEnter: namespace = error-404");
          // review this page 
          // var container = data.next.container, //is the next page
          // $container = $(container);
          // blocks();
        }
      }
    ]
  });

  barba.hooks.beforeLeave((data) => {

    var currentContainer = data.current.container, //is the current page
      $container = $(currentContainer);
    //
    // console.log("beforeleave -- add loading class");

    $("body").addClass("loading"); //review

    let animatedlogoType = "loader",
      animatedlogoTypeObject = document.querySelector('.animated-logo#loader_logo');

    animatedLogo(animatedlogoType, animatedlogoTypeObject)
    // forminator - moving the form back to the footer area.
    console.log("Thisis thecurrent $container", $container)

    // move formanitor if it exists
    if ($container.find(".forminator-placer").length) {
      var direction = 'out'; // to determine where to move the form

      console.log("we have a forminator placer - so move it:", direction);

      formPosition(direction);
    }

    console.log("beforeleave -- end");

  }); //barba.hooks.beforeLeave((data) =>


  barba.hooks.afterLeave((data) => {
    console.log("afterleave");
    var nextContainer = data.next.container, //is the next page
      $container = $(nextContainer);

    if ($('body').hasClass('toggled-on')) {
      // check if nav toggle is currenlty on
      // console.log("has toggled on");
      var addToggledOn = true;
    }

    var nextHtml = data.next.html,
      cookiesnotset,
      cookiesset,
      cookiesrefused,
      cookiesrevoke,
      cookiesaccepted;

    // console.log("body classes befor looking for them");

    if ($("body").hasClass("cookies-not-set")) {
      cookiesnotset = true;
      // console.log("cookies-not-set");
    }
    if ($("body").hasClass("cookies-set")) {
      cookiesset = true;
      // console.log("cookies-set");
    }
    if ($("body").hasClass("cookies-refused")) {
      cookiesrefused = true;
      // console.log("cookies-refused");
    }
    if ($("body").hasClass("cookies-revoke")) {
      cookiesrevoke = true;
      // console.log("cookies-revoke");
    }
    if ($("body").hasClass("cookies-accepted")) {
      cookiesaccepted = true;
      // console.log("cookies-accepted");
    };

    var response = nextHtml.replace(/(<\/?)body( .+?)?>/gi, '$1notbody$2>', nextHtml),
      bodyClasses = $(response).filter('notbody').attr('class'),
      gridIntialInit = true; // no longer do we need to completly re-initiate grid

    $("body").attr("class", bodyClasses);

    // remove the existing body clases & set with the correct ones
    $("body").removeClass('cookies-not-set cookies-set cookies-refused cookies-revoke cookies-accepted');
    // add the ones that were on previous page
    if (cookiesnotset == true) {
      $("body").addClass('cookies-not-set');
    }
    if (cookiesset == true) {
      $("body").addClass('cookies-set');
    }
    if (cookiesrefused == true) {
      $("body").addClass('cookies-refused');
    }
    if (cookiesrevoke == true) {
      $("body").addClass('cookies-revoke');
    }
    if (cookiesaccepted == true) {
      $("body").addClass('cookies-accepted');
    };

    if (data.next.url.path) {

      console.log("next path", data.next.url.path);

      removeUlSubActive(); // remove the active sub ul clases
      const updateItems = $(data.next.html).find('[data-barba-update] li');

      console.log("updateItems", updateItems);

      $('[data-barba-update] li').each(function (index) {

        console.log("barba li items updateItems", updateItems[index]);

        const newClasses = $(updateItems[index]).get(0).classList.value;
        $(this).attr('class', newClasses);

        // console.log("hello");
        // console.log("updateItems");
        // console.log("newClasses", newClasses);

      });
      // if we nee dto set the menu state - we need to ensure teh flickity var is update
      console.log("before initialMenuState"); // 
      console.log("is this flickity  var initialisedd?", flickityNav); //


      initialMenuState(flickityNav); //review the use of this var - flickityNav 
      // after we leave - why run "initial menuStuate" - unless its a consusing name
      //investigate this further

    }

    if (addToggledOn == true) {
      console.log("has toggled on - add class back on");
      document.body.classList.add("toggled-on");
    } // if (addToggledOn == true)

    setTimeout(function () {
      setgridheight(nextContainer, gridIntialInit); // update grid
      console.log("setgridheight -in timeout");
    }, 100);
    console.log("updateClasses about to start");

    updateClasses(touch, devGridOn_iso, devGridOn_rows, devGridOn_columns, devGridOn_baselines, devGridOn_vertlines, orientationValue); // update other classes 

    console.log("assignColors about to start");
    assignColors(); // update color variabless

    // let barbacontainer = document.querySelector('[data-barba="container"]');//barba container

    crumbObserver(nextContainer); // add interesection obsrever to the crumbn

    console.log("afterleave - end");


  }); //barba.hooks.afterLeave((data) =>


  barba.hooks.afterEnter((data) => {

    var nextContainer = data.next.container, //is the next page
      $container = $(nextContainer);

    console.log("GLOBAL - barba.hooks.after enter");

    // check if the loadoing has finished
    const loaderinterval = setInterval(() => {

      // console.log("loader-animation-finished");
      if ($("body").hasClass("loader-animation-finished")) {
        $("body").removeClass("loader-animation-finished");
        $("body").removeClass("loading");

        // console.log("afterEnter  -- loading class remove  - clearing interval - should have finished loading");

        if (window.location.hash) {
          // this works okay coming from single cervices page onto the services cateogoreis
          // but doesn work in  all instances
          // console.log("if(window.location.hash)", window.location.hash);
          // console.log("if(window.location.hash)", $container);
          scrollToSection(nextContainer, window.location.hash); // review this
        } else {
          // console.log("ELSE NO (window.location.hash) - so just scroll top");
          // console.log("scroll to top");
          scrollToTop(); // review this, and espeically inline with the other #scroll function above - they claishing?
          // maybe need to check if hash exist and then run either of the fuyncitons accoridbgly
        }

        console.log("GLOBAL - barba.hooks.after enter - FINISHED");

        // console.log("afterEnter  -- loading class remove  - clearing interval");
        clearInterval(loaderinterval);

      }
    }, 10);

    closeNavigation($container); // review this

    //mailinglist Toggle
    // mailingToggle();
    //animated arrows
    animatedArrowsInit();
    //set nav heights
    assignNavHeightValues();

    console.log("GLOBAL - barba.hooks.after enter - END");

    // // Reinitialize Google Analytics tracking
    // if (typeof gtag === 'function') {
    //   gtag('config', 'G-V0KD24WGN6', {
    //     'page_path': window.location.pathname
    //   });
    // }
    if (typeof gtag === 'function') {
      console.log("gtag", gtag);
      // console.log("gtag - page path", window.location.pathname);
      // console.log("gtag - page title", document.title);
      gtag('event', 'page_view', {
        page_path: window.location.pathname,
        page_title: document.title
      });
    }

  }); //barba.hooks.afterEnter((data) =>


} //export default function init()